import { apiRegister } from '../lib/api';
import { toast } from '../lib/toast';
import type { AppStateManager } from '../app';

const SITE_KEY = '0x4AAAAAADOVaCQ5Ijio7h2w';
let themeListener: ((e: Event) => void) | null = null;

export function renderRegisterPage(container: HTMLElement, app: AppStateManager): void {
  if (themeListener) { window.removeEventListener('kalpha-theme-changed', themeListener); themeListener = null; }
  container.innerHTML = `
    <div class="text-center mb-8 animate-fade-in-up">
      <div class="w-20 h-20 rounded-[24px] mx-auto mb-4 flex items-center justify-center shadow-xl" style="background: linear-gradient(135deg, #2d6a4f, #1b4332);">
        <svg width="44" height="44" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient id="rbubble" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stop-color="#74c69d"/>
              <stop offset="100%" stop-color="#40916c"/>
            </linearGradient>
          </defs>
          <path d="M28 32C28 26.5 32.5 22 38 22h24c5.5 0 10 4.5 10 10v20c0 5.5-4.5 10-10 10H48l-10 10 2-10h-2c-5.5 0-10-4.5-10-10V32z" fill="url(#rbubble)"/>
          <text x="50" y="50" font-family="system-ui, -apple-system, sans-serif" font-size="34" font-weight="800" fill="#ffffff" text-anchor="middle" dominant-baseline="middle" style="letter-spacing: -1px;">K</text>
          <circle cx="70" cy="28" r="5" fill="#ff6b6b"/>
        </svg>
      </div>
      <h1 class="text-2xl font-bold tracking-tight mb-1 text-primary">회원가입</h1>
      <p class="text-secondary text-sm">Kalphaotalk에 오신 것을 환영합니다</p>
    </div>
    <form id="register-form" class="space-y-3.5 animate-fade-in-up stagger-2">
      <div><label class="block text-sm font-semibold mb-1.5 ml-1 form-label">아이디</label><input id="reg-username" type="text" autocomplete="username" required class="input-field w-full" placeholder="영문, 숫자, _ (3~30자)"><p class="text-xs mt-1 ml-1 text-tertiary">영문, 숫자, 언더스코어만 사용 가능</p></div>
      <div><label class="block text-sm font-semibold mb-1.5 ml-1 form-label">닉네임</label><input id="reg-displayname" type="text" autocomplete="name" required class="input-field w-full" placeholder="표시될 이름을 입력하세요"></div>
      <div><label class="block text-sm font-semibold mb-1.5 ml-1 form-label">비밀번호</label>
        <div class="relative">
          <input id="reg-password" type="password" autocomplete="new-password" required class="input-field w-full" placeholder="8자 이상 입력하세요" style="padding-right:2.5rem">
          <button type="button" class="btn-toggle-pw absolute right-3 top-1/2 -translate-y-1/2 text-tertiary hover:text-primary transition-colors p-1" aria-label="비밀번호 표시" data-target="reg-password">
            <svg class="icon-eye" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            <svg class="icon-eye-off hidden" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
          </button>
        </div>
      </div>
      <div><label class="block text-sm font-semibold mb-1.5 ml-1 form-label">비밀번호 확인</label>
        <div class="relative">
          <input id="reg-password-confirm" type="password" autocomplete="new-password" required class="input-field w-full" placeholder="비밀번호를 다시 입력하세요" style="padding-right:2.5rem">
          <button type="button" class="btn-toggle-pw absolute right-3 top-1/2 -translate-y-1/2 text-tertiary hover:text-primary transition-colors p-1" aria-label="비밀번호 표시" data-target="reg-password-confirm">
            <svg class="icon-eye" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>
            <svg class="icon-eye-off hidden" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/><line x1="1" y1="1" x2="23" y2="23"/></svg>
          </button>
        </div>
        <p id="pw-match-msg" class="text-xs mt-1 ml-1 hidden"></p>
      </div>
      <div id="turnstile-register" class="flex justify-center"></div>
      <div id="register-error" class="error-text text-sm hidden px-1"></div>
      <button type="submit" class="btn btn-primary w-full py-3.5 mt-2 text-sm">회원가입</button>
    </form>
    <div class="mt-6 text-center animate-fade-in-up stagger-3">
      <div class="relative"><div class="absolute inset-0 flex items-center"><div class="w-full border-t divider"></div></div><div class="relative flex justify-center text-xs"><span class="px-3 divider-text">또는</span></div></div>
      <p class="text-sm mt-5 text-secondary">이미 계정이 있으신가요? <button id="btn-to-login" class="font-semibold link ml-1">로그인</button></p>
    </div>`;

  // 비밀번호 표시/숨김 토글
  document.querySelectorAll('.btn-toggle-pw').forEach((btn) => {
    btn.addEventListener('click', function(this: HTMLElement) {
      const targetId = this.getAttribute('data-target')!;
      const input = document.getElementById(targetId) as HTMLInputElement;
      const eye = this.querySelector('.icon-eye')!;
      const eyeOff = this.querySelector('.icon-eye-off')!;
      const isHidden = input.type === 'password';
      input.type = isHidden ? 'text' : 'password';
      eye.classList.toggle('hidden', !isHidden);
      eyeOff.classList.toggle('hidden', isHidden);
      this.setAttribute('aria-label', isHidden ? '비밀번호 숨기기' : '비밀번호 표시');
    });
  });

  // 실시간 비밀번호 일치 검증
  const pwInput = document.getElementById('reg-password') as HTMLInputElement;
  const pwConfirm = document.getElementById('reg-password-confirm') as HTMLInputElement;
  const pwMatchMsg = document.getElementById('pw-match-msg')!;
  function checkPwMatch() {
    if (!pwConfirm.value) { pwMatchMsg.classList.add('hidden'); return; }
    if (pwInput.value === pwConfirm.value) {
      pwMatchMsg.textContent = '비밀번호가 일치합니다';
      pwMatchMsg.className = 'text-xs mt-1 ml-1 text-kalpha-600';
      pwMatchMsg.classList.remove('hidden');
    } else {
      pwMatchMsg.textContent = '비밀번호가 일치하지 않습니다';
      pwMatchMsg.className = 'text-xs mt-1 ml-1 text-red-500';
      pwMatchMsg.classList.remove('hidden');
    }
  }
  pwInput.addEventListener('input', checkPwMatch);
  pwConfirm.addEventListener('input', checkPwMatch);

  // Turnstile 렌더링
  let tsToken = '';
  let tsWidgetId: string | null = null;
  const tsContainer = document.getElementById('turnstile-register')!;
  function renderTurnstile(theme: string = document.documentElement.classList.contains('dark') ? 'dark' : 'light') {
    tsContainer.innerHTML = '';
    try {
      if ((window as any).turnstile) {
        tsWidgetId = (window as any).turnstile.render('#turnstile-register', {
          sitekey: SITE_KEY,
          theme,
          callback: (token: string) => { tsToken = token; },
          'error-callback': () => {
            tsContainer.innerHTML = '<p class="text-sm text-red-500 text-center">보안 인증을 불러오지 못했습니다. 새로고침 해주세요.</p>';
          }
        });
      } else {
        tsContainer.innerHTML = '<p class="text-sm text-red-500 text-center">보안 인증 스크립트를 로드하지 못했습니다.</p>';
      }
    } catch {
      tsContainer.innerHTML = '<p class="text-sm text-red-500 text-center">보안 인증 초기화 오류</p>';
    }
  }
  renderTurnstile();

  // 다크모드 변경 시 Turnstile 동기화
  const onThemeChange = (e: Event) => {
    const theme = (e as CustomEvent).detail?.theme || (document.documentElement.classList.contains('dark') ? 'dark' : 'light');
    if (tsWidgetId && (window as any).turnstile) {
      try { (window as any).turnstile.remove('#turnstile-register'); } catch {}
      tsWidgetId = null;
    }
    renderTurnstile(theme);
  };
  themeListener = onThemeChange;
  window.addEventListener('kalpha-theme-changed', onThemeChange);

  const form = document.getElementById('register-form') as HTMLFormElement;
  const err = document.getElementById('register-error')!;
  const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const u = (document.getElementById('reg-username') as HTMLInputElement).value.trim();
    const n = (document.getElementById('reg-displayname') as HTMLInputElement).value.trim();
    const p = (document.getElementById('reg-password') as HTMLInputElement).value;
    const pc = (document.getElementById('reg-password-confirm') as HTMLInputElement).value;
    if (!u || !n || !p) { err.textContent = '모든 필드를 입력해주세요.'; err.classList.remove('hidden'); return; }
    if (u.length < 3 || u.length > 30) { err.textContent = '아이디는 3~30자'; err.classList.remove('hidden'); return; }
    if (!/^[a-zA-Z0-9_]+$/.test(u)) { err.textContent = '영문,숫자,_만 가능'; err.classList.remove('hidden'); return; }
    if (p.length < 8) { err.textContent = '비밀번호 8자 이상'; err.classList.remove('hidden'); return; }
    if (p !== pc) { err.textContent = '비밀번호 불일치'; err.classList.remove('hidden'); return; }
    if (!tsToken) { err.textContent = '로봇 인증을 완료해주세요.'; err.classList.remove('hidden'); return; }
    btn.disabled = true; btn.textContent = '가입 중...'; err.classList.add('hidden');
    try {
      const r = await apiRegister(u, p, n, tsToken);
      if (r.success && r.data) { toast('회원가입이 완료되었습니다. 로그인해주세요.', 'success'); setTimeout(() => app.navigateTo('login'), 1000); }
      else { err.textContent = r.error || '가입 실패'; err.classList.remove('hidden'); tsToken = ''; try { (window as any).turnstile?.reset('#turnstile-register'); } catch {} }
    } catch { err.textContent = '서버 연결 실패'; err.classList.remove('hidden'); }
    finally { btn.disabled = false; btn.textContent = '회원가입'; }
  });
  document.getElementById('btn-to-login')!.addEventListener('click', () => app.navigateTo('login'));
}
